import { createContext } from "react";

const NotificationsContext = createContext();

export default NotificationsContext;
